import { default as _91id_93BFsqCz84OlMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment/[id].vue?macro=true";
import { default as appointment4ncSC6VP8uMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment.vue?macro=true";
import { default as _91id_93HRHF7HXDZLMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/event/[id].vue?macro=true";
import { default as eventMG25hgU7bDMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/event.vue?macro=true";
import { default as eventIFrameR3rSFYnbf1Meta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrame.vue?macro=true";
import { default as eventIFramePreviewVLWVJ0ic5jMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFramePreview.vue?macro=true";
import { default as eventIFrameTestlSMZVIzNXhMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrameTest.vue?macro=true";
import { default as index0rtA5eEYxFMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/index.vue?macro=true";
import { default as _91registration_93x5jvtRxS7gMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview/[registration].vue?macro=true";
import { default as overviewb3ND1DhYL9Meta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview.vue?macro=true";
import { default as participantsNbIwn3afpEMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participants.vue?macro=true";
import { default as participantsDetailsQU4UJk31zMMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participantsDetails.vue?macro=true";
import { default as paymentaYAMxhtvUHMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/payment.vue?macro=true";
import { default as registrationDetailsBLveyMsdUXMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/registrationDetails.vue?macro=true";
import { default as regStartzv4BEuFPRSMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regStart.vue?macro=true";
import { default as regSummaryEqGNmAyrFgMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regSummary.vue?macro=true";
import { default as _91id_93VHO3qBacPEMeta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id].vue?macro=true";
import { default as registrationVhqF8YoCW4Meta } from "/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration.vue?macro=true";
export default [
  {
    name: "appointment___de",
    path: "/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___de",
    path: "/termin/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "appointment___en",
    path: "/en/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___de",
    path: "/event",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___de",
    path: "/veranstaltung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___en",
    path: "/en/event",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "eventIFrame___de",
    path: "/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrame___en",
    path: "/en/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___de",
    path: "/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___en",
    path: "/en/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___de",
    path: "/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___en",
    path: "/en/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "overview___de",
    path: "/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___de",
    path: "/uebersicht/:registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "overview___en",
    path: "/en/overview",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___en",
    path: ":registration()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "registration___de",
    path: "/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___de",
    path: "/anmeldung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___de",
    path: "teilnehmer",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___de",
    path: "teilnehmerDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___de",
    path: "zahlung",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___de",
    path: "anmeldungsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___de",
    path: "start",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___de",
    path: "zusammenfassung",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "registration___en",
    path: "/en/registration",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___en",
    path: "/en/registration/participants",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___en",
    path: "/en/registration/participantsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___en",
    path: "/en/registration/payment",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___en",
    path: "/en/registration/registrationDetails",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___en",
    path: "/en/registration/start",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___en",
    path: "/en/registration/summary",
    component: () => import("/home/forge/amosweb.de/releases/20250618135452/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  }
]